import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SideNavbar from './helpers/SideNavbar';
import { Button, Modal, Form } from 'react-bootstrap';
import 'react-quill/dist/quill.snow.css';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faEye, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import noDataImage from "../assets/nodata.png"
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Swal from 'sweetalert2';

const UsersListUnderClient = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const guid = localStorage.getItem("guid");
  const UserID = localStorage.getItem("UserID");
  const ClientID =  localStorage.getItem('ClientID') 

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getallusers`, 
        {params:{
          ClientID: ClientID,
          LoggedInUserID: UserID,  // Pass the logged-in user's ID
          Type:"Admin"
        }});
        setUsers(response.data);
        
        setLoading(false);
      } catch (err) {
        console.error('Failed to fetch posts:', err.message);
        setLoading(false);
      }
    };

    fetchPosts();
  }, [UserID]);



  const handleAdd = () => {
    navigate(`/adduser`);
  };

  const handleresetpassword = (Guid) => {
    navigate(`/resetpassword/${Guid}`);
  };

  const toggleUserStatus = async (user) => {
    const updatedStatus = !user.IsActive;
    setLoading(true)
    try {
      const response = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/updateuserstatus`, {
        UserID: user.UserID,
        IsActive: updatedStatus,
        ClientID:ClientID,
        Email:user.Email
      });
      setLoading(false)

      if (response.data.message === 'User status updated successfully') {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Done',
          showConfirmButton: false,
          timer: 3000
        });
        setUsers(users?.map(u => u.UserID === user.UserID ? { ...u, IsActive: updatedStatus } : u));

      }else  if (response.data.message === 'Can not Add') {
                        Swal.fire({
                          position: 'center',
                          icon: 'error',
                          title: 'You have already 20 users',
                          showConfirmButton: false,
                          timer: 3000
                        });
                       }
                        else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Error updating status!',
          showConfirmButton: false,
          timer: 3000
        });
      }

    } catch (error) {
      console.error('Error updating user status:', error);
    }
  };

  

  return (
    <SideNavbar>
      <div className="card shadow-sm p-3" style={{ border: 'none', backgroundColor: '#fff' }}>
      <div className="card-header d-flex justify-content-between" style={{ border: 'none', backgroundColor: '#fff' }}>
        <div className=''>
        <Link to={localStorage.getItem('RoleID') == '4' ? '/Pagehome' : (localStorage.getItem('RoleID') == '1' ? '/home' : '/adminhome')}>
                  <h5 className="welcome-text mt-4" style={{ fontSize: '20px', color: '#2e3192', textAlign: 'left' }}><i class="fa fa-arrow-left" style={{marginRight:'30px'}}aria-hidden="true"></i>Users List</h5>
                    </Link>
                              </div>
        <div>
        <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Add New User</Tooltip>)}>
  
          <button className="btn btn-primary mr-3" onClick={() => { handleAdd() }} style={{ backgroundColor: "#2e3192" }}>
            <FontAwesomeIcon icon={faPlus} style={{ color: '#fff', cursor: 'pointer' }} />
          </button>
          </OverlayTrigger>
        </div>
      </div>
        <hr />
        <div className="container mt-5">
          {loading ? (
            <div className='spinner'></div>
          ) : users.length === 0 ? (
            <div style={{ textAlign: 'center' }}>
              <img src={noDataImage} alt="No Data" style={{ width: '50%' }} />
              <p style={{ color: '#2e3192', fontSize: '20px' }}>No Users available</p>
            </div>
          ) : (
            <div className="row">
              {users.map(user => {
                return (
                  <div className="col-md-4" key={user.UserID}>
                    <div className="card mb-4" style={{ height: 200 }}>
                      <div className='card-body schedule-card'>
                    
                     <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Username</Tooltip>)}>
                      <div className='mt-3'><b style={{ color: "#2e3192" }}>Username:</b> {user.UserName}</div>
                       </OverlayTrigger>
                       <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Email</Tooltip>)}>
                        <div className='mt-3'><b style={{ color: "#2e3192" }}>Email:</b> {user.Email}</div>
                        </OverlayTrigger>
                                          </div>
                                          <div className='card-footer text-center'>
                                          {/* <div className='card-footer text-center d-flex justify-content-between'> */}
                                          {/* <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Reset Password</Tooltip>)}>
                                          <button
    className={`btn btn-${user.IsActive ? 'success' : 'danger'}`}
    onClick={() => handleresetpassword(user.Guid)}
  >
    <i className="fa fa-key" aria-hidden="true" style={{ fontSize: 20, color: user.IsActive ? "#fff" : "#fff" }}></i>
  </button>
  </OverlayTrigger> */}
  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>{user.IsActive ? 'De-Activate' : 'Activate'}</Tooltip>)}>

  <button
    className={`btn btn-${user.IsActive ? 'success' : 'danger'}`}
    onClick={() => toggleUserStatus(user)}
  >
    <i className={`fa fa-${user.IsActive ? 'toggle-on' : 'toggle-off'}`} aria-hidden="true" style={{ fontSize: 20, color: user.IsActive ? "#fff" : "#fff" }}></i>
  </button>
  </OverlayTrigger>
</div>

                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
       </SideNavbar>
  );
};

export default UsersListUnderClient;
